/* eslint-disable max-len */
const PostersModule = () => import(/* webpackChunkName: "posters" */ '@/components/modules/printServices/PostersModule.vue');
const DigitalMarketingCourseModule = () => import(/* webpackChunkName: "digitalmarketingcourse" */ '@/components/modules/norticAcademy/DigitalMarketingCourseModule.vue');

const POSTERS = 'Posters';
const DIGITAL_MARKETING_COURSE = 'DigitalMarketingCourse';

const subModules = {
  [POSTERS]: {
    component: PostersModule,
    name: POSTERS,
    path: '/printservices/posters',
    props: { moduleKey: POSTERS },
  },
  [DIGITAL_MARKETING_COURSE]: {
    component: DigitalMarketingCourseModule,
    name: DIGITAL_MARKETING_COURSE,
    path: '/norticacademy/digitalmarketingcourse',
    props: { moduleKey: DIGITAL_MARKETING_COURSE },
  },
};

export default subModules;
